import React from 'react';

const CGV = () => {
  return (
    <main className="bg-white min-h-screen pt-28 pb-16 px-6 sm:px-8">
      <div className="max-w-4xl mx-auto text-gray-800">
        <h1 className="text-3xl sm:text-4xl font-semibold text-[#1e3a5f] mb-8">Conditions generales de vente</h1>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Objet</h2>
          <p>
            Les presentes CGV encadrent les prestations de medecine esthetique proposees par MN Medecine Esthetique,
            selon les indications medicales et devis communiques lors de la consultation.
          </p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Tarifs et reglement</h2>
          <p>
            Les tarifs sont indiques en euros TTC. Le reglement intervient selon les modalites communiquees lors de la
            prise en charge. Un devis peut etre etabli pour les protocoles de soins.
          </p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Annulation et report</h2>
          <p>
            Toute annulation ou demande de report doit etre effectuee au plus tot. En cas d&apos;annulations repetees ou
            tardives, la clinique se reserve le droit d&apos;adapter les conditions de prise de rendez-vous.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-medium">Remboursement</h2>
          <p>
            Les actes de medecine esthetique n&apos;ouvrent en principe pas droit au remboursement par l&apos;Assurance Maladie.
            Les conditions de remboursement eventuel de sommes versees sont precisees au cas par cas, en fonction de la
            situation medicale et contractuelle.
          </p>
        </section>
      </div>
    </main>
  );
};

export default CGV;
